import { useI18n } from 'builder/hooks/useI18n'
import { useUser } from 'builder/hooks/useUser'
import { useFeaturesConfig } from 'builder/hooks/featureConfig/useFeaturesConfig'
import { useJobTracker } from 'builder/components/CareerPathJobDetails/components/JobDetails/components/RecommendedJobs/hooks/useJobTracker'

import { fromNow } from 'builder/utils/formatDate'
import { Job } from 'builder/components/FindJob/JobSearchResult/types'
import { getDefaultLogoForCompany } from 'builder/components/FindJob/utils/getDefaultLogoForCompany'

import { TooltipV2 } from 'builder/components/Tooltip'
import * as Styles from './styles'

const TRANSLATIONS = 'builder.dashboard.recommended_jobs_widget.card'

type CardProps = {
  card: Job
  viewedJobs: string[]
  handleClick: (jobTitle?: string) => void
}

export const Card = ({ card, viewedJobs, handleClick }: CardProps) => {
  const user = useUser()
  const { i18n } = useI18n()
  const { features } = useFeaturesConfig()
  const { isPresent, handleAddJobBoard } = useJobTracker(card, true)

  const isViewed = viewedJobs?.includes(card.external_slug_id)

  const formatDate = (date: string) => {
    const formatedDate = fromNow(date, { addSuffix: true })
    const posted = i18n.t(`${TRANSLATIONS}.posted`)
    return `${posted} ${formatedDate}`
  }

  const saveCard = (e: React.MouseEvent) => {
    e.stopPropagation()
    handleAddJobBoard()
  }

  return (
    <Styles.Container
      data-testid="recommended-job-card"
      data-job-id={card.external_slug_id}
      onClick={() => handleClick(card.job_title)}
    >
      <Styles.LogoContainer>
        <Styles.Logo src={card.company_logo || getDefaultLogoForCompany()} />
      </Styles.LogoContainer>
      <Styles.InfoContainer>
        <Styles.JobContainer>
          <Styles.JobTitle>{card.job_title}</Styles.JobTitle>
          <Styles.JobSubTitle>
            {card.company} • {card.location}
          </Styles.JobSubTitle>
        </Styles.JobContainer>
        <Styles.JobInfoContainer>
          <Styles.ListedDate>
            {isViewed && i18n.t(`${TRANSLATIONS}.viewed`) + ' • '} {formatDate(card.posted_at)}
          </Styles.ListedDate>
          {!card.is_easy_apply && features?.autoApply && !!user?.scopes?.autoApply && (
            <TooltipV2
              multiline
              value={i18n.t(`${TRANSLATIONS}.auto_apply_tooltip`)}
              position="top"
            >
              <Styles.AutoApplyContainer>
                •
                <Styles.AutoApplyIcon />
                <Styles.AutoApplyText>{i18n.t(`${TRANSLATIONS}.auto_apply`)}</Styles.AutoApplyText>
              </Styles.AutoApplyContainer>
            </TooltipV2>
          )}
        </Styles.JobInfoContainer>
      </Styles.InfoContainer>
      <Styles.ActionContainer>
        {/* <TooltipV2 multiline value={i18n.t(`${TRANSLATIONS}.match_tooltip`)} position="top">
          <Styles.Score score={65}>{!isPhone && i18n.t(`${TRANSLATIONS}.match`)}</Styles.Score>
        </TooltipV2> */}
        <Styles.ActionButton onClick={saveCard}>
          {isPresent ? <Styles.HeartIconFilled /> : <Styles.HeartIcon />}
        </Styles.ActionButton>
      </Styles.ActionContainer>
    </Styles.Container>
  )
}
